

// import React from 'react';
// import { Dropdown } from 'primereact/dropdown';
// import { Chart } from 'primereact/chart';

// import './DashboardWidget.scss';



// const DashboardWidget = ({
//     title,
//     className = '',
//     children,

//     chartType = null,
//     chartData = null,
//     chartOptions = null,

//     filterOptions = [],
//     selectedFilter = null,
//     onFilterChange = null
// }) => {
// const defaultOptions = {
//     maintainAspectRatio: false,
//     legend: {
//         display: chartType !== 'pie'
//     }
// };
//     const renderContent = () => {

//         if (chartType && chartData) {
//             return (
//                 <Chart
//                     type={chartType}
//                     data={chartData}
//                     options={{...defaultOptions,chartOptions}}
//                     style={{
//                         width: '100%',
//                         height: chartType === 'pie'
//                 ? '320px'
//                 : '250px'
//                     }}
//                 />
//             );
//         }

//         return children;
//     };

//     return (
//         <div className={`dashboard-widget ${className}`}>

//             <div className="widget-header">

//                 <div className="widget-title">
//                     {title}
//                 </div>

//                 <div className="widget-actions">

//                     {filterOptions.length > 0 && (
//                         <Dropdown
//                             value={selectedFilter}
//                             options={filterOptions}
//                             onChange={onFilterChange}
//                             placeholder="Select"
//                             style={{ width: '120px' }}
//                         />
//                     )}

//                     <i
//                         className="pi pi-info-circle widget-info"
//                         title="More Information"
//                     />

//                 </div>

//             </div>

//             <div className="widget-content">
//                 {renderContent()}
//             </div>

//         </div>
//     );
// };

// export default DashboardWidget;



import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Chart } from 'primereact/chart';

import './DashboardWidget.scss';

const DashboardWidget = ({
    title,
    className = '',
    children,

    chartType = null,
    chartData = null,
    chartOptions = null,

    filterOptions = [],
    selectedFilter = null,
    onFilterChange = null,

    showViewButton = false,
    viewButtonLabel = 'View',
    onViewClick = null
}) => {

    const defaultOptions = {
        maintainAspectRatio: false,
        legend: {
         display: !['pie', 'doughnut'].includes(chartType)
        }
    };

    const mergedOptions = {
        ...defaultOptions,
        ...chartOptions
    };

    const renderContent = () => {

        if (chartType && chartData) {
            return (
                <Chart
                    type={chartType}
                    data={chartData}
                    options={mergedOptions}
                    style={{
                        width: '100%',
                        height: '100%'
                    }}
                />
            );
        }

        return children;
    };

    return (
        <div className={`dashboard-widget ${className}`}>

            {/* HEADER */}
            <div className="widget-header">

                <div className="widget-title">
                    {title}
                </div>

                <div className="widget-actions">
                    <i
                        className="pi pi-info-circle widget-info"
                        title="More Information"
                    />
                </div>

            </div>

            {/* BODY */}
            <div className="widget-content">
                {renderContent()}
            </div>

            {/* FOOTER */}
            {(filterOptions.length > 0 || showViewButton) && (
                <div className="widget-footer">

                    <div className="widget-footer-left">

                        {filterOptions.length > 0 && (
                            <Dropdown
                                value={selectedFilter}
                                options={filterOptions}
                                onChange={onFilterChange}
                                placeholder="Select"
                                style={{ width: '120px' }}
                            />
                        )}

                    </div>

                    <div className="widget-footer-right">

                        {showViewButton && (
                            <Button
                                label={viewButtonLabel}
                                className="p-button-text p-button-sm"
                                onClick={onViewClick}
                            />
                        )}

                    </div>

                </div>
            )}

        </div>
    );
};

export default DashboardWidget;